import { render, staticRenderFns } from "./EntSearchConfig.vue?vue&type=template&id=2201cf2a"
import script from "./EntSearchConfig.vue?vue&type=script&lang=js"
export * from "./EntSearchConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports